import { render, staticRenderFns } from "./BaseSelectGroupWithProvider.vue?vue&type=template&id=5a3159c9&"
import script from "./BaseSelectGroupWithProvider.vue?vue&type=script&lang=js&"
export * from "./BaseSelectGroupWithProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports